<template>
  <div class="chat" @click.stop="hideDialog">
    <!--------------------顶部导航---------------------->
    <div class="topNav" v-if="showNav">
              <span class='topBackBtn' @click="goLogin">
                <van-icon name="arrow-left"/>
              </span>
      <span class="serviceTitle">智能客服</span>
    </div>
    <!--欢迎语-->
    <div class="slogan">
      <p><img src="../../assets/img/robotHead.png" class="sloganImg">欢迎进入智能客服系统</p>
    </div>
    <!--水印-->
    <watermark :markInfo="markInfo"></watermark>
    <div :class="['chatContentBox',{setarea:showNav}]" id="chatContentArea">
      <!-------------------历史信息---------------------->
      <history-chat :showHistoryBtn="showHistoryBtn" :currentDialogueNum="currentDialogueNum"
                    :profilePhoto="profilePhoto"
                    @findHistory="findHistoryFn"></history-chat>
      <!----------------------问题引导--------------------->
      <div class="guideBox">
        <div>
          <img :src="profilePhoto" alt="系统" class="headPortrait">
        </div>
        <div class="guideBoxContent">
          <div class="triangleLeft"></div>
          <p>您好，我是智能客服-{{ loginInfo.aiNickname }}，您可以咨询“{{ loginInfo.knowledgeTypeNames }}”相关的问题。</p>
          <div>
            <ul>
              <li class="guideLi" style="font-weight:600;">请您选择问题类别：</li>
              <li class="guideLi" :class={currentLi:item.currentLi} v-for="(item,index) in questionList" :key="index"
                  @click="getQuestion(item,allQuestions)"><span>{{ index + 1 }}、</span>{{ item.ktName }}
              </li>
              <li class="guideLi" v-if="questionList[0].questionLevel!==1">
                <img src="../../assets/img/backBtn.png" alt="返回" @click="returnBtn" class="backBtn">
              </li>
            </ul>
            <p class="label-text">此消息由智能客服机器人发送</p>
          </div>
        </div>
      </div>
      <!--------------------聊天内容------------------------>
      <div v-for="(item, index) in msglist" :key="index">
        <!------------机器人对话框------------>
        <div class="chat-model" v-if="item.csdrUtype===0&&item.csdrType!==62&&item.csdrType!==63">
          <!--头像-->
          <div>
            <img :src="profilePhoto" alt="系统" class="headPortrait">
          </div>
          <!--对话-->
          <div class="chat-content chat-content-l">
            <div class="triangleLeft"></div>
            <!--消息内容-->
            <msgType :info="item"></msgType>
            <!--转人工-->
            <div v-if="item.csdrType===60||item.csdrType===61">
              <p>{{ item.csdrContent }}：
                <span @click="checkTime" class='manualService'>
                  <van-icon name="phone" class="phone"/>转人工
                </span>
              </p>
            </div>
            <!--评价-->
            <div v-if='item.csdrType===51'>
              <p>
                <span>{{ item.csdrContent }}</span>
                <span class="evaluateButton" @click="openEvaluate">
                  <img src="../../assets/img/evaluate.png" alt="评价" class="evaluate">
                  点击反馈
                </span>
              </p>
            </div>
          </div>
        </div>
        <!--人工服务分界线-->
        <div class="personLine" v-if="item.csdrType===63">
          <div class="separateLineBox">
            <span class="historyText">{{ item.csdrContent }}</span>
          </div>
        </div>
        <div class="personLine" v-if="item.csdrType===62">
          <div class="separateLineBox">
            <span class="historyText">人工服务中</span>
          </div>
        </div>
        <!------------客服对话框------------>
        <div class="chat-model" v-if="item.csdrUtype===2&&item.msgWithdrawStatus===0">
          <!--头像-->
          <div>
            <img src="../../assets/img/service.png" alt="客服" class="headPortrait">
          </div>
          <div class="chat-content chat-content-l">
            <div class="triangleLeft"></div>
            <!--消息内容-->
            <msgType :info="item"></msgType>
          </div>
        </div>
        <!--被撤回后展示的消息-->
        <div v-if="item.msgWithdrawStatus===1" class="withdrawMsgBox">
          <p>{{ item.msgWithdrawHint }}</p>
        </div>
        <!------------用户对话框------------>
        <div class="chat-model" style="justify-content: flex-end;" v-if="item.csdrUtype===1">
          <!--对话-->
          <div class="chat-content chat-content-r">
            <div class="triangle"></div>
            <!--消息内容-->
            <msgType :info="item"></msgType>
          </div>
          <!--头像-->
          <div>
            <img width="35px" height="35px" fit="fill" round src="../../assets/img/personal@3x.png" alt="用户"/>
          </div>
        </div>
      </div>
      <!-----------------------评价----------------------->
      <van-action-sheet v-model="showEvaluate" title="请您为本次服务评价">
        <div class="evaluateMain">
          <!--          <van-rate-->
          <!--            :readonly="evaluateReadonly"-->
          <!--            @change="changeEvaluate"-->
          <!--            v-model="evaluateData.feedbackScore"-->
          <!--            :size="25"-->
          <!--            color="#ffd21e"-->
          <!--            void-icon="star"-->
          <!--            void-color="#eee"-->
          <!--          />-->
          <!--          <p class="evaluateContent">-->
          <!--            <span v-show="evaluateData.feedbackScore===1">非常不满意</span>-->
          <!--            <span v-show="evaluateData.feedbackScore===2">不满意</span>-->
          <!--            <span v-show="evaluateData.feedbackScore===3">一般</span>-->
          <!--            <span v-show="evaluateData.feedbackScore===4">满意</span>-->
          <!--            <span v-show="evaluateData.feedbackScore===5">非常满意</span>-->
          <!--          </p>-->
          <van-field
            :readonly="evaluateReadonly"
            v-model="evaluateData.feedbackContent"
            :autosize="evaluateAutosize"
            rows="1"
            clearable
            border
            label-width="50"
            label="反馈："
            type="textarea"
            placeholder="请输入您的反馈信息"
          />
          <van-button type="info" class="submitEvaluate" @click="submitEvaluateFn" :disabled="evaluateReadonly"
                      size="small">提交
          </van-button>
        </div>
      </van-action-sheet>
      <!-----------------------问题引导图标----------------------->
      <div class="guideImage" v-if="ifGuideImage&&!guideBoxPopup" @click="findGuideFn">
        <img src="../../assets/img/backBtn.png" alt="" class="sendImg">
      </div>

      <van-popup v-model="guideBoxPopup" position="right" round :style="{width: '80%', }"
                 :overlay-style="{backgroundColor: 'rgba(0,0,0,0.6)'}">
        <div class="guideBoxContent" style="margin: 40px 0 20px 15px">
          <div class="triangleLeft"></div>
          <div class="debaoImgBox">
            <p>
              <img :src="profilePhoto" alt="系统" class="debaoImg">
            </p>
            <p class="debaoTips">{{ loginInfo.aiNickname }}的提示</p>
          </div>
          <p>您好，我是智能客服-{{ loginInfo.aiNickname }}，您可以咨询“{{ loginInfo.knowledgeTypeNames }}”相关的问题。
          </p>
          <div>
            <ul>
              <li class="guideLi" style="font-weight:600">请您选择问题类别：</li>
              <li class="guideLi" :class={currentLi:item.currentLi} v-for="(item,index) in questionList" :key="index"
                  @click="getQuestion(item,allQuestions)"><span>{{ index + 1 }}、</span>{{ item.ktName }}
              </li>
              <li class="guideLi" v-if="questionList[0].questionLevel!==1">
                <img src="../../assets/img/backBtn.png" alt="返回" @click="returnBtn" class="backBtn">
              </li>
            </ul>
          </div>
          <p class="label-text">此消息由智能客服机器人发送</p>
        </div>
      </van-popup>
    </div>
    <!-------------------------转人工排队中----------------------->
    <!--    <van-dialog v-model="queueUpDialog" title="转人工排队中" @cancel="cancelPhoneFn" show-cancel-button-->
    <!--                :showConfirmButton="false" cancelButtonText="取消排队" :closeOnClickOverlay="false">-->
    <!--      <p class='queueUp'>{{ queueUpMsg }}</p>-->
    <!--    </van-dialog>-->
    <van-dialog v-model="queueUpDialog" title="友情提示" show-cancel-button
                :showConfirmButton="false" cancelButtonText="关闭" :closeOnClickOverlay="false">
      <p class='queueUp'>{{ queueUpMsg }}</p>
    </van-dialog>
    <!-------------------------输入框----------------------->
    <div class="input-container">
      <input type="text" v-model="newMessage" placeholder="请输入内容" @focus="inputFocus" @blur="inputBlur"
             @touchstart="touchFocus"
             class="inputBox"
             @keyup.enter="sendMessage" ref="input"/>
      <span class="sendImgBox"> <img src="../../assets/img/Vector.png" alt="发送" class="sendImg"
                                     @click="sendMessage"> </span>
    </div>
  </div>
</template>

<script>
import {ImagePreview, Toast} from 'vant'
import {
  cancelPhone,
  getConversation,
  getConversationInfo,
  getQuestionList, isServicingTime,
  recordPhone,
  submitEvaluate
} from '../../service/getData'
import {getCheckLoginInfo, getConfig, getLoginInfo} from '../../util/auth'
import HistoryChat from '../../components/chat/historyChat'
import attachment from '../../components/chat/attachment'
import msgType from '../../components/chat/msgType'
import watermark from '../../components/chat/watermark'
import {changeBaseImg, checkExpiredFn} from '../../assets/js/common'

export default {
  name: 'chatDetail',
  components: {HistoryChat, attachment, msgType, watermark},
  data () {
    return {
      loginInfo: getLoginInfo(), // 登录成功后，后端返回的信息
      accountInfo: JSON.parse(sessionStorage.getItem('accountInfo')),
      profilePhoto: sessionStorage.getItem('profilePhoto') || require('../../assets/img/Robot-head-2.png'), // base64格式用户头像
      markInfo: { // 水印内容
        msg: '智旅途AI智能',
        domId: 'chatContentArea'
      },
      showNav: false, // 是否展示导航栏
      /* -----------------------顶部问题列表--------------------------- */
      // 问题列表（所有层级）
      allQuestions: [],
      // 问题列表（当前层级）
      questionList: [{questionLevel: 1}],
      currentLi: false, // 是否显示当前问题样式
      /* -----------------------聊天信息--------------------------- */
      currentDialogueNum: '', // 当前会话id
      showHistoryBtn: false, // 是否显示历史消息按钮
      showEvaluate: false, // 是否显示评分
      evaluateData: {
        csdrId: '',
        feedbackScore: 0, // 评分
        feedbackContent: '' // 评价
      },
      evaluateAutosize: {
        maxHeight: 100,
        minHeight: 100
      },
      evaluateReadonly: false, // 是否禁止评论
      // 聊天内容
      msglist: [],
      newMessage: '',
      chatContent: null,
      ifGuideImage: false,
      guideBoxPopup: false,
      queueUpDialog: false, // 是否显示排队弹窗
      queueUpMsg: '您的转人工服务已受理，请稍等。'
    }
  },
  mounted () {
    let checkLoginInfo = getCheckLoginInfo()
    if (checkLoginInfo && checkLoginInfo !== '' && checkLoginInfo !== null && checkLoginInfo !== undefined) {
      // 获取问题列表
      this.getQuestionListFn()
      // 获取头像将头像转成base64并存储
      this.getBase64Img()
    } else {
      this.$router.push({
        path: '/error',
        query: {
          msg: '网络出现异常，请返回后重新进入应用。'
        }
      })
    }

    this.chatContent = document.getElementsByClassName('chatContentBox')[0]
    this.chatContent.addEventListener('scroll', this.initScroll)

    // 是否展示导航栏，返回按钮
    this.getConfigInfoFn()
  },
  beforeDestroy () {
    // 退出页面销毁socket
    this.$socketApi.closeWebSocket()
    // 退出页面销毁addEventListener监听事件
    this.chatContent.removeEventListener('scroll', this.initScroll)
  },
  methods: {
    // 隐藏按钮弹窗
    hideDialog (val) {
      this.$store.commit('setShowAllBtn', false)
    },
    // 获取头像将头像转成base64并存储
    async getBase64Img () {
      if (this.loginInfo.aiAvatar) {
        let url = await changeBaseImg(this.$originApi + this.loginInfo.aiAvatar)
        if (url !== null) {
          sessionStorage.setItem('profilePhoto', url)
          this.profilePhoto = url
        }
      }
    },
    // 跳转登录
    goLogin () {
      this.$router.push({name: 'login'})
    },
    // 查看问题引导
    findGuideFn () {
      this.guideBoxPopup = true
    },
    // 点击查看历史记录回调
    findHistoryFn (val) {
      this.initScroll()
    },
    // 监听页面滚动，是否展示查看问题引导图标
    initScroll (e) {
      let guideBoxHeight = document.getElementsByClassName('guideBox')[0]
      if ((guideBoxHeight.offsetTop + guideBoxHeight.offsetHeight > this.chatContent.scrollTop) && (guideBoxHeight.offsetTop < this.chatContent.scrollTop + this.chatContent.clientHeight)) {
        // console.log('进入可视区域')
        this.ifGuideImage = false
      } else {
        // console.log('离开可视区域')
        this.ifGuideImage = true
      }
    },
    /* -----------------------顶部问题列表--------------------------- */
    // 获取问题列表
    getQuestionListFn () {
      let params = {
        companyAccount: this.loginInfo.companyAccount
      }
      getQuestionList(params).then(res => {
        if (res.code === 0) {
          this.allQuestions = res.data
          // 初始化设置问题列表
          this.initQuestionList(this.allQuestions)
          // 获取当前会话信息
          this.getConversationInfoFn()
        } else {
          Toast.fail(res.msg)
        }
      })
    },
    // 初始化设置问题列表
    initQuestionList (allQuestions, level = 1) {
      // 给问题的每层添加默认参数
      // questionLevel来标明层级
      // currentLi代表是否选中当前问题
      allQuestions.forEach(item => {
        item.questionLevel = level
        item.currentLi = false
        if (item.subs && item.subs.length > 0) {
          this.initQuestionList(item.subs, level + 1)
        }
      })
      // 赋值给当前问题列表
      this.questionList = allQuestions
    },
    // 获取下一级问题，如果没有下一级，则为当前问题
    async getQuestion (item, questionsArr) {
      if (this.guideBoxPopup) {
        this.guideBoxPopup = false
      }
      for (const i of questionsArr) {
        if (i.ktId === item.ktId) {
          if (i.subs && i.subs.length > 0) {
            // 赋值当前问题列表
            this.questionList = i.subs
            // 设置选中样式
            this.setCurrentLi(-1)
          } else {
            // 当前最终提问
            // 设置选中样式
            this.setCurrentLi(item.ktId)

            // 验证token是否过期，过期重新登录
            checkExpiredFn()

            // 判断当前是否存在socket对象
            // if (this.$socketApi.isConnectFn()) {
            //   this.$socketApi.closeWebSocket()
            // }

            // 初始化socket
            this.$socketApi.initWebSocket(this.getsocketResult)

            // 发送当前提问信息给socket
            let msgNum = this.setMsgNum() // 消息编号
            this.$socketApi.sendSock({
              msgType: 20,
              context: item.ktId,
              msgNum
            })
          }
        } else if (i.subs && i.subs.length > 0) {
          this.getQuestion(item, i.subs)
        }
      }
    },
    // 问题列表返回按钮
    returnBtn () {
      this.getParents(this.questionList[0].ktPId, this.allQuestions)
    },
    // 获取上一级的所有数据
    getParents (id, allQuestions) {
      allQuestions.forEach(item => {
        if (item.ktId === id) {
          // 设置问题列表
          this.questionList = allQuestions
        } else if (item.subs && item.subs.length > 0) {
          this.getParents(id, item.subs)
        }
      })
    },
    // 设置选中样式
    setCurrentLi (id) {
      this.allQuestions.forEach(item => {
        if (item.ktId === id) {
          item.currentLi = true
        } else {
          item.currentLi = false
        }
      })
      this.questionList.forEach(item => {
        if (item.ktId === id) {
          item.currentLi = true
        } else {
          item.currentLi = false
        }
      })
      this.$forceUpdate()
    },
    /* -----------------------聊天信息--------------------------- */
    // 获取当前会话id和问题id
    getConversationInfoFn () {
      let params = {
        groupCompanyCode: this.loginInfo.groupCompanyCode,
        uniqueCode: this.loginInfo.uniqueCode,
        companyAccount: this.accountInfo
      }
      getConversationInfo(params).then(res => {
        if (res.code === 0) {
          let dialogueNum = res.data.dialogueNum // 会话id
          let context = res.data.context // 当前问题id
          // 如果有会话id，初始化一个websocket
          if (dialogueNum !== '' && dialogueNum !== null && dialogueNum !== undefined) {
            this.currentDialogueNum = dialogueNum
            this.$socketApi.initWebSocket(this.getsocketResult)
            // 获取当前会话内容
            this.getConversationFn(dialogueNum)
          }
          // 如果存在当前问题，选中当前问题
          if (context !== '' && context !== null && context !== undefined) {
            this.getParents(context, this.allQuestions)
            // 设置选中样式
            this.setCurrentLi(context)
          }
          // 检查是否有历史记录
          this.showHistoryBtn = res.data.hasHistoryDialogue
          // 保存评价id
          if (res.data.length > 0) {
            this.evaluateData.csdrId = res.data[0].csdrId
          }
        } else {
          Toast.fail(res.msg)
        }
      })
    },
    // 获取当前会话内容
    getConversationFn (csdCode) {
      let params = {csdCode}
      getConversation(params).then(res => {
        if (res.code === 0) {
          this.msglist = res.data.dialogueRecordList
          // 设置滚动条到最底部
          setTimeout(function () {
            let chatArea = document.getElementById('chatContentArea')
            chatArea.scrollTo(0, chatArea.scrollHeight)
          }, 1)
        } else {
          Toast.fail(res.msg)
        }
      })
    },
    // 发送消息
    sendMessage () {
      if (this.newMessage) {
        let msgNum = this.setMsgNum() // 消息编号
        const result = this.$socketApi.sendSock({
          msgType: 31,
          message: this.newMessage,
          msgNum
        })
        if (result === 'closed') {
          // 链接关闭提示
          this.msglist.push({csdrType: 31, csdrContent: '请您先选择问题类别。', csdrUtype: 0, msgWithdrawStatus: 0})
        } else {
          // 当前默认发送文本消息
          this.msglist.push({csdrType: 31, csdrContent: this.newMessage, csdrUtype: 1, msgNum, msgWithdrawStatus: 0})
        }
        this.newMessage = ''
      }
    },
    // 设置每条消息的消息编号
    setMsgNum () {
      let msgNum = ''

      const dialogueNum = this.currentDialogueNum
      if (dialogueNum) {
        const lastChars = dialogueNum.substring(dialogueNum.length - 4) // 会话编号后4位
        const timestamp = new Date().getTime() // 时间戳
        const randomInt = Math.floor(Math.random() * 900) + 100 // 三位随机数

        msgNum = lastChars + '-' + timestamp + '-' + randomInt
      }

      return msgNum
    },
    // 接收服务端发送过来的消息
    /*
    * 发送人类型csdrUtype：0：系统；1：用户；2：客服
    * 发送内容类型csdrType:10-连接；19-结束连接；90-心跳；20-上下文；31-文本；32-富文本；33-语音；41-附件；42-图片；51-评分；52-点赞 53-撤回消息 61-转人工 62-web端主动转人工；
    *
    * */
    getsocketResult (data) {
      console.log('页面接收到信息：', data)
      let info = JSON.parse(data)
      this.currentDialogueNum = info.dialogueNum
      if (info.msgType === 20 || info.msgType === 31 || info.msgType === 32 || info.msgType === 51 || info.msgType === 60 || info.msgType === 61 || info.msgType === 62 || info.msgType === 63) {
        // 普通文本类消息
        this.msglist.push({
          csdrType: info.msgType,
          csdrContent: info.message,
          csdrUtype: info.csdrUtype,
          lineLimit: 3,
          msgWithdrawStatus: 0,
          msgNum: info.msgNum
        })
        if (info.msgType === 51) {
          // 保存评价id
          this.evaluateData.csdrId = info.scoreCsdrId
        }
        if (info.msgType === 62) {
          this.queueUpDialog = false
        }
      } else if (info.msgType === 41) {
        // 附件类消息
        this.msglist.push({
          csdrType: info.msgType,
          csdrAtt: info.fileUrl,
          csdrAttName: info.fileName,
          csdrUtype: info.csdrUtype,
          msgWithdrawStatus: 0,
          msgNum: info.msgNum,
          csdrAttDownload: info.csdrAttDownload
        })
      } else if (info.msgType === 42) {
        // 图片类消息
        this.msglist.push({
          csdrType: info.msgType,
          csdrAtt: info.fileUrl,
          csdrUtype: info.csdrUtype,
          msgWithdrawStatus: 0,
          msgNum: info.msgNum
        })
      } else if (info.msgType === 19) {
        // 关闭socket
        this.$socketApi.closeWebSocket()
        // 初始化问题列表
        this.getQuestionListFn()
      } else if (info.msgType === 71) {
        // 转人工排队
        this.queueUpDialog = true
      } else if (info.msgType === 53) {
        // 消息撤回后提示语
        let msgArr = this.msglist
        msgArr.forEach(i => {
          if (i.msgNum === info.withdrawMsgNum) {
            i.msgWithdrawHint = info.message
            i.msgWithdrawStatus = 1
          }
        })
        this.msglist = msgArr
      }
    },
    // 输入框聚焦后，设置滚动条到最底部
    inputFocus () {
      // document.getElementsByClassName('input-container')[0].scrollIntoView()
      if (this.chatContent.scrollHeight > this.chatContent.clientHeight) {
        // 设置滚动条到最底部
        this.chatContent.scrollTop = this.chatContent.scrollHeight
      }

      // 监听如果是安卓手机，那么聊天输入框上移，反之不用
      // var u = navigator.userAgent
      // if (u.indexOf('Android') > -1 || u.indexOf('Linux') > -1) { // 安卓手机
      //   document.getElementsByClassName('input-container')[0].style.bottom = '300px'
      // } else {
      //   // window.scroll(0, 0)// 苹果
      // }
    },
    inputBlur () {
      // 失去焦点的时候，进行触发
      // 监听如果是安卓手机，那么聊天输入框恢复底部位置，反之不用
      // var u = navigator.userAgent
      // if (u.indexOf('Android') > -1 || u.indexOf('Linux') > -1) { // 安卓手机
      //   document.getElementsByClassName('input-container')[0].style.bottom = '0'
      // } else {
      //   // window.scroll(0, 0)// 苹果
      // }
    },
    // 查看大图
    showImg (img) {
      ImagePreview([img])
    },
    // 查看当前聊天消息全部信息
    watchDetail (index) {
      this.msglist[index].lineLimit = 'inherit'
    },
    // 打开评价弹窗
    openEvaluate () {
      this.showEvaluate = true
    },
    // 改变评分
    changeEvaluate (val) {
      console.log('val', val)
    },
    // 提交评价
    submitEvaluateFn () {
      let ifPass = true
      if (this.evaluateData.csdrId === '' || this.evaluateData.csdrId === null || this.evaluateData.csdrId === undefined) {
        Toast.fail('缺少评价id')
        ifPass = false
      } else if (this.evaluateData.feedbackContent === '' || this.evaluateData.feedbackContent.match(/^\s+$/) || this.evaluateData.feedbackContent === null || this.evaluateData.feedbackContent === undefined) {
        Toast.fail('请填写评价内容')
        ifPass = false
      }

      if (ifPass) {
        let params = {...this.evaluateData}
        submitEvaluate(params).then(res => {
          if (res.code === 0) {
            this.showEvaluate = false
            this.evaluateReadonly = true
          } else {
            Toast.fail(res.msg)
          }
        })
      }
    },
    // 记录转人工（toManualType：1.右上角转人工2.当前会话转人工）
    recordPhoneFn (toManualType) {
      let params = {
        clientId: this.accountInfo + '-' + this.loginInfo.groupCompanyCode + '-' + this.loginInfo.uniqueCode,
        dialogueNum: this.currentDialogueNum,
        toManualType
      }
      recordPhone(params).then(res => {
        if (res.code === 0) {
          this.queueUpMsg = '您的转人工服务已受理，请稍等。'
          this.queueUpDialog = true
        } else if (res.code === 1010090010) {
          this.queueUpMsg = '本次咨询已结束，期待下次咨询中为您服务。'
          this.queueUpDialog = true
        } else if (res.code === 1010010080) {
          this.queueUpMsg = '当前客服人员正在为您服务。'
          this.queueUpDialog = true
        } else if (res.code === 1010010090) {
          this.queueUpMsg = '很抱歉，目前咨询量大，您可先留言，稍后第一时间回复您。'
          this.queueUpDialog = true
        } else {
          Toast.fail(res.msg)
        }
      })
    },
    // 取消转人工
    cancelPhoneFn () {
      let params = {
        clientId: this.accountInfo + '-' + this.loginInfo.groupCompanyCode + '-' + this.loginInfo.uniqueCode,
        dialogueNum: this.currentDialogueNum
      }
      cancelPhone(params).then(res => {
        if (res.code === 0) {
          this.queueUpDialog = false
        } else {
          Toast.fail(res.msg)
        }
      })
    },
    // 是否展示导航栏，返回按钮
    getConfigInfoFn () {
      let configInfo = getConfig()
      if (configInfo) {
        this.showNav = configInfo.setting.settingsShowNavigationBar
        this.showBackBtn = configInfo.setting.settingsShowBackButton
      }
    },
    // 重新聚焦
    touchFocus () {
      document.getElementsByClassName('inputBox')[0].focus()
    },
    // 排队检查时间
    checkTime () {
      isServicingTime().then(res => {
        if (res.code === 0) {
          if (res.data.inServiceTiming) {
            // 转人工
            this.recordPhoneFn(2)
          } else {
            if (res.data.workday) {
              // 工作日非上班时间段
              this.queueUpMsg = `抱歉，当前为非上班时段，请于${res.data.serviceTiming}咨询人工服务，感谢您的理解。`
              this.queueUpDialog = true
            } else {
              // 非工作日
              this.queueUpMsg = `抱歉，当前为非工作日，请于工作日咨询人工服务，感谢您的理解。`
              this.queueUpDialog = true
            }
          }
        } else {
          Toast.fail(res.msg)
        }
      })
    }
  },
  watch: {
    msglist: {
      handler (val, old) {
        if (this.chatContent.scrollHeight > this.chatContent.clientHeight) {
          // 设置滚动条到最底部
          this.$nextTick(() => {
            this.chatContent.scrollTop = this.chatContent.scrollHeight
          })
        }
      },
      deep: true
    }
  }
}
</script>

<style scoped>
.chat {
  width: 100%;
  height: 100vh;
  background-color: #f2f3f5;
  overflow: hidden;
  font-size: 15px;
}

.topNav {
  position: relative;
  background: #fff;
  height: 40px;
  text-align: center;
  line-height: 40px;
}

.chatContentBox {
  background-color: #f2f3f5;
  width: 100%;
  height: calc(100vh - 110px);
  padding-bottom: 10px;
  overflow-y: scroll;
  overflow-x: hidden;
}

.setarea {
  height: calc(100vh - 140px);
}

.guideBox {
  display: flex;
  flex-direction: row;
  border-radius: 5px;
  max-width: 90%;
  word-break: break-all;
  word-wrap: break-word;
  /* top: 18px; */
  padding: 10px;
  border-radius: 5px;
}

.guideBoxContent {
  position: relative;
  word-break: break-all;
  word-wrap: break-word;
  /* top: 18px; */
  padding: 10px;
  /* padding-bottom: 0; */
  border-radius: 5px;
  background-color: white;
  margin-left: 15px;
}

.label-text {
  font-size: 12px;
  font-weight: 400;
  color: rgba(132, 126, 126, 1)
}

.debaoImgBox {
  text-align: center;
}

.debaoImg {
  width: 75px;
  height: 81px;
  vertical-align: middle;
}

.debaoTips {
  font-size: 20px;
  font-weight: 700;
  color: rgba(0, 0, 0, 1);
  padding: 12px 0;
}

.guideLi {
  height: 40px;
  line-height: 40px;
  border-bottom: 1px solid rgb(201, 196, 196);
  color: #1989fa;
}

ul .guideLi:last-child {
  border-bottom: none;
}

.chat-model {
  display: flex;
  flex-direction: row;
  margin: 10px 10px;
  margin-top: 20px;
}

.chat-content {
  position: relative;
  max-width: 69%;
  word-break: break-all;
  word-wrap: break-word;
  /* top: 18px; */
  padding: 10px;
  border-radius: 5px;
}

.chat-content-r {
  background: #448af7;
  color: #fff;
  margin-right: 15px;
}

.chat-content-l {
  background-color: white;
  margin-left: 15px;
}

.triangle {
  position: absolute;
  right: 10px;
  width: 0;
  height: 0;
  border-top: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 10px solid transparent;
  border-left: 10px solid #448af7;
  right: -16px;
  top: 8px;
}

.triangleLeft {
  position: absolute;
  width: 0;
  height: 0;
  border-top: 10px solid transparent;
  border-right: 10px solid white;
  border-bottom: 10px solid transparent;
  border-left: 10px solid transparent;
  left: -16px;
  top: 8px;
}

.input-container {
  position: fixed;
  bottom: 0;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: 20px;
  padding-bottom: calc(constant(safe-area-inset-bottom) - 10px); /*兼容 IOS<11.2*/
  padding-bottom: calc(env(safe-area-inset-bottom) - 10px); /*兼容 IOS>11.2*/
}

.inputBox {
  width: 80%;
  height: 35px;
  border-radius: 5px;
  border: 1px solid #adacac;
  padding-left: 10px;
  margin-right: 5px;
}

.sendImgBox {
  width: 32px;
  height: 32px;
  background-color: rgba(25, 105, 229, 1);
  border-radius: 32px;
  text-align: center;
  line-height: 32px;
}

.sendImg {
  width: 15px;
  height: 15px;
  vertical-align: middle;
}

.evaluateBox {
  font-size: 12px;
  margin-top: 15px;
  margin-left: 16%;
  max-width: 69%;
  height: 35px;
  background: white;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
}

.goodBox {
  display: inline-block;
  width: 20%;
}

.noGoodBox {
  display: inline-block;
  width: 20%;
}

.guideImage {
  position: fixed;
  bottom: 200px;
  right: 10px;
}

.manualService a {
  color: #1e90ff;
  margin-right: 10px;
  position: absolute;
  right: 0;
}

.historyBtnBox {
  margin: 20px 0;
  position: relative;
}

.showHistory {
  color: dodgerblue;
  text-align: center;
}

.cover {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.imgMsg {
  width: 150px;
}

.van-loading {
  display: inline-block;
  text-align: center;
  margin-left: 5px;
  vertical-align: bottom;
}

.separateLineBox {
  height: 0px;
  border: 0.5px dashed #c1bfbf;
  margin: 30px auto;
  width: 90%;
  text-align: center;
}

.historyText {
  font-size: 14px;
  color: #c1bfbf;
  background: #f2f3f5;
  padding:0 5px;
  text-align: center;
  position: relative;
  bottom: 10px;
}

.watchDetail {
  color: #448af7;
  font-size: 14px;
}

.talkMsg {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 3;
}

.fileBox {
  width: 150px;
  height: 40px;
  display: flex;
}

.fileIcon {
  width: 34px;
  margin-left: auto;
}

.fileSize {
  color: #adacac;
  font-size: 12px;
}

.headPortrait {
  width: 35px;
  height: 35px;
}

.backBtn {
  width: 28px;
  height: 28px;
  vertical-align: middle;
}

.call {
  color: #1e90ff;
}

.phone {
  width: 22px;
  vertical-align: middle;
}

.evaluateButton {
  color: #1e90ff;
}

.evaluate {
  width: 22px;
  vertical-align: middle;
}

.van-rate {
  width: 80%;
  display: flex;
  justify-content: space-around;
  margin: 0 auto;
}

.evaluateMain {
  padding: 20px;
  padding-top: 0px;
}

/deep/ .evaluateMain .van-field__label {
  margin-right: 0;
}

.evaluateContent {
  text-align: center;
  color: red;
  font-size: 16px;
  font-weight: bold;
  margin-top: 15px;
}

.submitEvaluate {
  width: 100%;
  margin-top: 10px;
}

.currentLi {
  color: red;
  font-weight: 600;
}

.van-popup--right.van-popup--round {
  border-radius: 10px 0 0 10px;
}

.richText {
  white-space: pre-wrap;
}

.personLine {
  color: #adacac;
  text-align: center;
  font-size: 14px;
}

.manualService {
  color: #448af7;
}

.queueUp {
  text-align: center;
  margin: 20px 0;
  padding: 0 10px;
}

.withdrawMsgBox {
  text-align: center;
  margin: 20px 0;
  font-size: 12px;
  color: #a9a5a5;
}

.slogan {
  position: relative;
  height: 40px;
  line-height: 40px;
  font-size: 16px;
  text-align: center;
  border-bottom: 1px solid #dbdbdb;
}

.sloganImg {
  width: 28px;
  vertical-align: middle;
  margin-right: 5px;
}

.topBackBtn {
  font-size: 18px;
  position: absolute;
  left: 5px;
}

</style>



// WEBPACK FOOTER //
// src/pages/chat/chatDetail.vue